import { Popover } from "antd";
import React from "react";
import { formatDateTime } from "../../utils/date_formatter";

interface ReportHistoryTooltipProps {
	title: React.ReactNode;
	data: any;
	children: React.ReactNode;
}

function ReportHistoryTooltip({
	title,
	data,
	children,
}: ReportHistoryTooltipProps) {
	const content = () => {
		const authorName = data.is_anonymous
			? "Anonymous user"
			: (data.author_name ?? data.assigned_by_name);
		const reviewerName = data.reviewer_name;

		return (
			<div className="flex flex-col w-96 gap-3">
				<div className="flex justify-between gap-5">
					<span>Submitted on</span>
					<span>
						{formatDateTime(data?.submitted_on ?? "")}{" "}
						{authorName ? `by ${authorName}` : ""}
					</span>
				</div>

				<div className="flex justify-between gap-5">
					<span>Approved on</span>
					<span>
						{formatDateTime(data?.approved_on ?? "")}{" "}
						{reviewerName ? `by ${reviewerName}` : ""}
					</span>
				</div>

				<div className="flex justify-between gap-5">
					<span>Closed on</span>
					<span>
						{formatDateTime(data?.closed_on ?? "")}{" "}
						{reviewerName ? `by ${reviewerName}` : ""}
					</span>
				</div>
			</div>
		);
	};

	if (!data) return null;
	return (
		<Popover
			title={title}
			content={content}
			placement={"right"}
			rootClassName="review-history-popover"
		>
			{children}
		</Popover>
	);
}

export default ReportHistoryTooltip;
